module.exports = __webpack_public_path__ + "static/media/sheeptheproject.20c2ec94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/sheeptheproject.png
// module id = 1131
// module chunks = 0